<icc-list
    [searchable]="true"
    [items]="woods"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (select)="selectWood($event)"
    [selected]= "selected"
></icc-list>
